import { Col, Image, Row } from "react-bootstrap"
import billplus from '../../assets/images/billplusLogo.png'
import fitplus from '../../assets/images/fitPlusLogo.png'
import { useSelector } from "react-redux"

const FooterSection = () => {
    const tenant = useSelector((state)=> state?.enquiry?.tenant)
    return (
        <>
            <Row className="mt-6">
                <Col lg={12} className="d-flex justify-content-center align-items-center">
                    <text>Powered by</text>
                </Col>
                <Col lg={12} className="d-flex justify-content-center align-items-center">
                    <Image src={tenant?.flavor == 'billplus' ? billplus : fitplus} height={40} style={{ width: 'auto' }} />
                </Col>
            </Row>
        </>
    )
}

export default FooterSection;